export default "__VITE_ASSET__8ece1d09__"